import { useMemo } from "react";
import { useSelector } from "../../../../imports/generalImport";
import { Box, Typography, List, Divider, ListItem } from "../../../../imports/muiImport";
import { handleAmount } from "../../../../shared/extra";

function OrderSummaryItem({
  label,
  value,
  highlight = false,
  labelWidth = "65%",
  valueWidth = "35%",
}) {
  return (
    <ListItem sx={{ justifyContent: "space-between", height: 39.63 }}>
      <Typography
        sx={{
          minWidth: labelWidth,
          fontSize: "13.5px",
          fontWeight: 700,
          color: highlight ? "primary.main" : "inherit",
          textTransform: highlight ? "capitalize" : "none",
        }}
      >
        {label}
      </Typography>

      <Typography
        sx={{
          minWidth: valueWidth,
          fontSize: highlight ? "14.5px" : "13.5px",
          fontWeight: 700,
          textAlign: "center",
          color: highlight ? "primary.main" : "textPrimary.main",
        }}
      >
        {value}
      </Typography>
    </ListItem>
  );
}

const calculateTotalValue = (items = []) =>
  items.reduce((sum, item) => sum + (item.AMOUNT || 0) * (item.QUANTITY || 0), 0);

const calculateTotalDiscount = (items = []) =>
  items.reduce(
    (sum, item) => sum + ((item.AMOUNT || 0) - (item.TOTAL || 0)),
    0
  );

function PaymentOrderReceipt() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData || {});
  const DENOMINATION_STORE_DATA = useSelector(
    (state) => state.Denominations?.allData || []
  );

  const filteredItems = useMemo(
    () => DENOMINATION_STORE_DATA.filter((i) => i?.QUANTITY >= 1),
    [DENOMINATION_STORE_DATA]
  );

  const TOTAL_VALUE = useMemo(() => calculateTotalValue(filteredItems), [filteredItems]);
  const TOTAL_DISCOUNT = useMemo(() => calculateTotalDiscount(filteredItems), [filteredItems]);
  const NET_PAY = TOTAL_VALUE - TOTAL_DISCOUNT;

  // REUSABLE DATA ARRAY
  const summaryData = [
    {
      label: "Total Value",
      value: `₹ ${handleAmount(TOTAL_VALUE)}`,
    },
    {
      label: PRODUCTDETAILS.productType || "Discount",
      value: `₹ ${handleAmount(TOTAL_DISCOUNT)}`,
    },
    {
      label: "Total Payout",
      value: `₹ ${handleAmount(NET_PAY)}`,
      highlight: true,
    },
  ];

  return (
    <Box sx={{ px: { xl: 1 }, height: "100%" }}>
      <Typography
        variant="body1"
        gutterBottom
        sx={{
          color: { xs: "primary.main", sm: "textPrimary.main" },
          fontSize: { xs: "1.2rem", sm: "13.5px", lg: "15px" },
          fontWeight: 700,
          textAlign: { xs: "center", lg: "left" },
          mb: { xs: 1, md: 0 },
        }}
      >
        Order Review
      </Typography>

      <Box
        sx={{
          borderRadius: { xs: 1, lg: 2 },
          backgroundColor: {
            xs: "backgroundPrimary.main",
            lg: "secondary.light",
          },
          py: { xs: 0, lg: "10px" },
          px: { xs: 0, lg: "8px" },
          minHeight: { xs: "100px", lg: "140px", xl: "180px" }
        }}
      >
        <List>
          {summaryData.map((item, index) => (
            <Box key={index}>
              <OrderSummaryItem
                label={item.label}
                value={item.value}
                highlight={item.highlight}
              />
              {index !== summaryData.length - 1 && <Divider component="li" />}
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
}

export default PaymentOrderReceipt;


